import { FunctionComponent, ReactNode, useState } from "react";
import { observer } from "mobx-react-lite";

import { getStoreContextProvider, store } from "../../../stores/StoreContext";

interface IStoreProviderProps {
  children: ReactNode;
}

// Singleton provider component, resolved once at module scope so it isn't recreated on every render
const StoreContextProvider = getStoreContextProvider();

const RawStoreProvider: FunctionComponent<IStoreProviderProps> = ({ children }: IStoreProviderProps) => {
  // Trial to fix losing store on hot reloads => but real solution is using another store library like Zustand or Redux
  const [state] = useState(store);

  return <StoreContextProvider value={state}>{children}</StoreContextProvider>;
};

export const StoreProvider = observer(RawStoreProvider);
